import { createAsyncThunk } from '@reduxjs/toolkit'
import { http } from 'src/libs'
import { NOT_FOUND } from 'src/utils/errorCode'

import {
  type ICardResponse,
  type IFormPayload,
  type IFraudPayload,
  type IScheme,
} from './type'

interface IResponse {
  errorCode: string
  responseCode: string
  responseMessage: string
  responseMethod: string
}

export interface IAccessTokenResponse extends IResponse {
  responseData: string | IScheme[]
}

export interface ICardsApiResponse extends IResponse {
  responseData: ICardResponse
}

export const getCard = createAsyncThunk(
  'getCard',
  async (payload: IFormPayload, thunkApi) => {
    try {
      const { response, error } = await http({
        method: 'POST',
        path: {
          url: 'GET_CARD',
        },
        data: payload,
      })

      if (error) {
        return thunkApi.rejectWithValue(error)
      }

      const data = response?.data as ICardsApiResponse

      if (data.errorCode === NOT_FOUND) {
        return thunkApi.rejectWithValue({ message: 'Card Not Found!' })
      }

      return thunkApi.fulfillWithValue(data.responseData)
    } catch (error) {
      return thunkApi.rejectWithValue(error)
    }
  }
)

export const reportFraudulent = createAsyncThunk(
  'reportFradulent',
  async (payload: IFraudPayload, thunkApi) => {
    try {
      const { response, error } = await http({
        method: 'POST',
        path: {
          url: 'FRAUDULENT',
        },
        data: payload,
      })

      if (error) {
        return thunkApi.rejectWithValue(error)
      }

      const data = response?.data as ICardsApiResponse

      if (data.errorCode === NOT_FOUND) {
        return thunkApi.rejectWithValue({ message: 'Card Not Found!' })
      }
    } catch (error) {
      return thunkApi.rejectWithValue(error)
    }
  }
)
